'use client'

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { supportQueries } from '@/entities/support'
import { UserType } from '@/entities/user'

type SearchParams = {
  keyword?: string
  category?: string
}

type Props = {
  userType: UserType
  searchParams: SearchParams
}

export const useFAQsInfinite = ({ userType, searchParams }: Props) => {
  const { data, hasNextPage, fetchNextPage } = useInfiniteQuery({
    ...supportQueries.faqsInfinite(userType, searchParams),
    placeholderData: keepPreviousData,
  })

  const faqs = data?.pages.flatMap(page => page.content) ?? []
  const totalElements = data?.pages[0]?.totalElements ?? 0

  return {
    faqs,
    totalElements,
    hasNextPage,
    fetchNextPage,
  }
}
